/**
 * Typed Redux Hooks
 */

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Convenience hook for user state
 */
export const useUser = () => {
  return useAppSelector((state) => state.user);
};

/**
 * Convenience hook for user data only
 */
export const useUserData = () => {
  return useAppSelector((state) => state.user.user);
};

/**
 * Convenience hook for authentication status
 */
export const useIsAuthenticated = () => {
  return useAppSelector((state) => state.user.isAuthenticated);
};
